module.exports = __webpack_public_path__ + "img/linkedin_icon.67168f04.svg";